import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { WhatsappLogo, ForkKnife, ClipboardText, Lightning, Check, ArrowRight, Storefront, ChartLineUp } from "@phosphor-icons/react";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />

      {/* Hero */}
      <section className="max-w-7xl mx-auto px-6 pt-12 pb-20 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 fade-in">
          <span className="nb-badge mb-6" data-testid="landing-badge">Tanpa Coding · Untuk Bisnis Lokal</span>
          <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] mt-4">
            Formulir & Menu Digital, <br/>
            <span className="bg-[#A7E4C0] border-2 border-[#121212] px-3 inline-block rotate-[-1deg] mt-2">langsung ke WhatsApp</span>
          </h1>
          <p className="text-lg text-[#4A4A4A] mt-7 max-w-xl leading-relaxed">
            Bikin formulir pemesanan, reservasi, survei, sampai menu Dine-in cukup dalam 2 menit.
            Setiap respon pelanggan otomatis masuk ke chat WhatsApp Anda. Praktis, tanpa coding.
          </p>
          <div className="flex flex-wrap gap-3 mt-8">
            <Link to="/register" className="nb-btn nb-btn-primary text-lg px-6 py-4" data-testid="hero-cta-register">
              Mulai Gratis <ArrowRight size={20} weight="bold" />
            </Link>
            <a href="#cara-kerja" className="nb-btn text-lg px-6 py-4" data-testid="hero-cta-demo">
              Lihat Cara Kerja
            </a>
          </div>
          <div className="flex gap-6 mt-8 text-sm text-[#4A4A4A]">
            <div className="flex items-center gap-2"><Check size={18} weight="bold" /> Gratis dipakai</div>
            <div className="flex items-center gap-2"><Check size={18} weight="bold" /> Setup &lt; 2 menit</div>
            <div className="flex items-center gap-2"><Check size={18} weight="bold" /> Bisa diakses mobile</div>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="nb-card nb-card-lg overflow-hidden rotate-[2deg]">
            <img
              src="https://images.pexels.com/photos/5053765/pexels-photo-5053765.jpeg"
              alt="WhatsApp chat"
              className="w-full h-80 object-cover"
            />
          </div>
          <div className="nb-card absolute -bottom-6 -left-6 p-4 bg-[#FFD166] rotate-[-3deg] max-w-[220px]">
            <div className="flex items-center gap-2 mb-1">
              <WhatsappLogo size={20} weight="bold" />
              <span className="font-bold text-sm">Pesanan Baru</span>
            </div>
            <p className="text-sm leading-snug">Meja 4 · 2x Nasi Goreng · 1x Es Teh</p>
            <p className="mono text-xs mt-2">Total Rp 78.000</p>
          </div>
          <div className="nb-card absolute -top-4 -right-4 p-3 bg-[#A7E4C0] rotate-[4deg]">
            <ChartLineUp size={28} weight="bold" />
            <p className="font-display font-black text-2xl">+124</p>
            <p className="text-xs font-bold">respon hari ini</p>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="max-w-3xl">
          <span className="nb-badge">Fitur Inti</span>
          <h2 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-4">
            Semua yang dibutuhkan UKM untuk jualan via WhatsApp.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          <div className="nb-card p-6 fade-in-delay-1">
            <div className="w-12 h-12 bg-[#A7E4C0] border-2 border-[#121212] rounded-lg flex items-center justify-center mb-4">
              <ClipboardText size={26} weight="bold" />
            </div>
            <h3 className="font-display font-bold text-xl mb-2">Form Builder Drag-free</h3>
            <p className="text-[#4A4A4A]">
              Tambahkan field text, dropdown, tanggal, upload file - tanpa kode. Cocok buat reservasi, survei, pendaftaran.
            </p>
          </div>
          <div className="nb-card p-6 fade-in-delay-2">
            <div className="w-12 h-12 bg-[#FFD166] border-2 border-[#121212] rounded-lg flex items-center justify-center mb-4">
              <ForkKnife size={26} weight="bold" />
            </div>
            <h3 className="font-display font-bold text-xl mb-2">Menu Digital Dine-in</h3>
            <p className="text-[#4A4A4A]">
              Pelanggan scan QR di meja, pilih menu + foto + harga, pesanan langsung masuk WhatsApp kasir/dapur.
            </p>
          </div>
          <div className="nb-card p-6 fade-in-delay-3">
            <div className="w-12 h-12 bg-[#CDB4DB] border-2 border-[#121212] rounded-lg flex items-center justify-center mb-4">
              <WhatsappLogo size={26} weight="bold" />
            </div>
            <h3 className="font-display font-bold text-xl mb-2">Integrasi WhatsApp</h3>
            <p className="text-[#4A4A4A]">
              Tiap submit otomatis bikin pesan terformat di chat WhatsApp Anda. Tidak butuh API berbayar.
            </p>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section id="cara-kerja" className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-5">
            <span className="nb-badge">Cara Kerja</span>
            <h2 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-4">3 langkah, langsung jualan.</h2>
            <p className="text-[#4A4A4A] mt-5 leading-relaxed">
              Tidak perlu install aplikasi tambahan. Pelanggan tidak perlu daftar akun apa pun.
              Tinggal share link / QR code.
            </p>
          </div>
          <div className="md:col-span-7 grid gap-4">
            {[
              { n: "01", t: "Daftar & buat form/menu", d: "Isi nomor WhatsApp tujuan, lalu desain field atau menu sesuka Anda." },
              { n: "02", t: "Bagikan link / QR", d: "Tempel di stiker meja, share di bio Instagram, atau kirim via broadcast." },
              { n: "03", t: "Terima pesanan di WhatsApp", d: "Pelanggan klik tombol kirim, chat masuk ke nomor Anda otomatis terformat rapi." },
            ].map((s, i) => (
              <div key={i} className="nb-card p-5 flex gap-5 items-start">
                <div className="mono font-bold text-2xl bg-[#121212] text-[#FDFBF7] px-3 py-1 rounded-lg">{s.n}</div>
                <div>
                  <h3 className="font-display font-bold text-xl">{s.t}</h3>
                  <p className="text-[#4A4A4A] mt-1">{s.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Use cases */}
      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-12 gap-8 items-stretch">
          <div className="md:col-span-5 nb-card overflow-hidden">
            <img src="https://images.unsplash.com/photo-1424847651672-bf20a4b0982b" alt="Menu" className="w-full h-full object-cover min-h-[320px]" />
          </div>
          <div className="md:col-span-7 nb-card p-8 bg-[#A7E4C0]">
            <span className="nb-badge bg-white">Cocok untuk</span>
            <h2 className="font-display font-black text-3xl sm:text-4xl mt-4 tracking-tight">Bisnis kecil yang tumbuh cepat.</h2>
            <div className="grid sm:grid-cols-2 gap-3 mt-6">
              {["Warung & Cafe", "Reservasi Salon", "Pendaftaran Kursus", "Survei Pelanggan", "Pre-Order Katering", "Booking Tour"].map((u) => (
                <div key={u} className="flex items-center gap-2 font-medium">
                  <Storefront size={20} weight="bold" /> {u}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="nb-card nb-card-lg p-10 sm:p-14 bg-[#121212] text-[#FDFBF7] text-center">
          <Lightning size={40} weight="fill" className="mx-auto" />
          <h2 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-4">Siap terima pesanan via WA?</h2>
          <p className="text-lg opacity-80 mt-3 max-w-xl mx-auto">
            Daftar sekarang dan buat form / menu pertama Anda dalam 2 menit.
          </p>
          <Link to="/register" className="nb-btn nb-btn-primary text-lg mt-6 inline-flex" data-testid="cta-bottom-register">
            Mulai Gratis Sekarang <ArrowRight size={20} weight="bold" />
          </Link>
        </div>
      </section>

      <footer className="border-t-2 border-[#121212] py-8 text-center text-sm text-[#4A4A4A]">
        © {new Date().getFullYear()} Layanan lainnya RS Mulya · Formulir & menu digital yang masuk langsung ke WhatsApp.
      </footer>
    </div>
  );
}
